<template>
	<b-row style="min-height: 100vh;" align-v="center" align-h="center">
		<b-col class="text-center">
			<span class="display-4 d-block"> {{ $t('thankYou') }} </span>
			<div class="mb-4 lead">{{ $t('formRecieved') }}</div>
		</b-col>
	</b-row>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
